/* eslint-disable */

export const valueSchema = {
  type: 'object',
  properties: {
    value: {
      type: 'array',
      items: {
        type: 'object',
        properties: {
          key: {
            type: 'string',
            enum: [
              'FORK_LIFTS_ARE_INSPECTED_AND_MAINTAINED_ON_A_REGULAR_BASIS',
              'FORKLIFT_TRUCKS_HAVE_WARNING_LIGHTS_AND_AUDIBLE_SIGNALS_FOR_REV',
              'FACILITY_PROHIBITS_OVERLOADING_MATERIALS_ON_FORKLIFT_TRUCKS',
              'THE_FACILITY_PROHIBITS_USING_FORKLIFTS_TO_LIFT_WORKERS_SO_THAT_',
              'THE_FACILITY_PROHIBITS_LOCATING_BATTERY_CHARGING_AREAS_FOR_ELEC',
              'FORKLIFT_ROUTES_ARE_CLEARLY_MARKED',
              'FORKLIFTS_ARE_PARKED_IN_DESIGNATED_LOCATION_S_WHEN_NOT_IN_USE',
              'NONE_OF_THE_ABOVE',
            ],
          },
          isChecked: {
            type: 'boolean',
          },
          followUp: {
            type: ['object', 'null'],
            properties: {
              value: {
                type: 'string',
              },
            },
            required: ['value'],
          },
        },
        required: ['key', 'isChecked', 'followUp'],
      },
    },
  },
  required: ['value'],
}

export const validationSchema = {
  type: 'array',
  minItems: 1,
  items: {
    type: 'object',
    required: ['id', 'name'],
    additionalProperties: true,
    properties: {
      id: {type: 'string', minLength: 1},
      name: {type: 'string', minLength: 1},
    },
  },
}

export const answerSchema = {
  type: 'object',
  additionalProperties: false,
  properties: {
    does_the_fac_have_any_of_the_following_safety_measures_in_place_10: valueSchema,
  },
}
